import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

export const PageShell = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="App">
      <Navbar />
      {children}
      <FinalCTA
        onStart={() => navigate("/estimer")}
        onCallback={() => navigate("/", { state: { scrollTo: "contact" } })}
      />
      <Footer />
    </div>
  );
};

export const PageHero = ({ label, title, sub, testid }) => (
  <section data-testid={testid} className="bg-ivory pb-16 pt-32 sm:pb-20 sm:pt-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">{label}</p>
      <h1 className="mt-4 max-w-3xl font-display text-4xl font-medium leading-[1.08] tracking-tight text-navy sm:text-6xl">
        {title}
      </h1>
      {sub && (
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-stone-500 sm:text-base">{sub}</p>
      )}
    </div>
  </section>
);
